import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeleteClassBookingService, GetClassBookingService,TeacherJoinLinkClassBookingService } from '../../services/class_booking/classBookingServices';
import { GetTeacherSearchService } from '../../services/class_booking/TeacherServices';
import SettingsMenu from '../staticscreens/SettingsMenu';

function DemoBookingList() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)

  const [step, setstep] = useState("Pending")

  let stages = ['Pending','Completed','Cancelled','User Not Joined','Partially Joined']

  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})
  const [teachers, setteachers] = useState([])


  const [search, setsearch] = useState({ text: '',text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false, teacher:'' })

  useEffect(() => {
    getdata()
  }, [step, page])

  async function getdata() {
    const response = await GetClassBookingService(page, search?.text, step,search?.teacher,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetClassBookingService(1,search?.text, step,search?.teacher,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,text1:'',teacher:'' })
    setpage(1)
    const response = await GetClassBookingService(1, '', step,'','','')
    setdata(response?.data)
  }

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 -> 12
    return `${h}:${minutes} ${ampm}`;
  };


  async function deleteData() {
    const response = await DeleteClassBookingService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  async function searchTeacher(e){
    const response = await GetTeacherSearchService(e,1,'Counsellor')
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setteachers(arr)
  }

  async function openMeetfun(d){
    if(d?.meet_link?.includes('meet')){
      window.open(d?.meet_link)
    }else{
      const separator = d?.meet_link?.includes("?") ? "&" : "?";
      window?.open(`myacademy://join?room=${d?.meet_link}&role=teacher`)
    }
  }

  async function copyInvite(d) {
  const text = d?.meet_link;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      // Fallback for unsupported browsers
      const textArea = document.createElement("textarea");
      textArea.value = text;

      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      document.execCommand("copy");

      textArea.remove();
    }

    toast.success("Invite Link Copied to Clipboard");
  } catch (error) {
    console.error("Failed to copy:", error);
    toast.error("Failed to copy invite link");
  }
  }

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <SettingsMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Demo Booking ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <div className='mr-2 flex items-center mt-1 md:mt-0'>
               {roles?.includes('admin') &&
                <div className='flex items-center'>
                <div className='mr-2 w-[130px]'>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.teacher == '' ? null : search?.teacher}
                  bordered={false}
                  onSearch={searchTeacher}
                  className='border rounded-[5px] h-[26px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={teachers}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select Teacher</span>}
                  onChange={(e)=>setsearch({...search,teacher:e})}
                  />
                </div>
                <div className='flex items-center'>
                    <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />
                    <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />
                </div>    
                </div>}  

                <input id="search_text" placeholder='Search text' type='text' value={search.text1} onChange={(e) => setsearch({ ...search, text1: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonFilledAutoWidth btnName="Add Data" onClick={() => navigator('create')} />
              </div>
            </div>
          </div>


<div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {stages?.map((s)=>(
                <h6 onClick={()=>{setstep(s);setpage(1)}} className={`font-[600] ${step === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
            </div>


          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Section Name</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Teacher Info </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Student List</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Booking Info</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px] px-2 py-1 border-r'>
                        <span className='font-bold'>{d?.section_name}</span><br></br>
                        <span className='font-bold'>Class No : {d?.class?.label}</span><br></br>
                        <div className='flex items-center mt-1'>
                          {(d?.class_completed === 'Pending' && d?.meet_link) && <h6 onClick={()=>openMeetfun(d)} className='mt-1 cursor-pointer w-max bg-blue-300 font-[600] p-1 text-[10px] rounded'>Join Meet</h6>}
                          {(d?.class_completed === 'Pending' && d?.meet_link) && <h6 onClick={()=>copyInvite(d)} className='mt-1 ml-1 cursor-pointer w-max bg-orange-300 font-[600] p-1 text-[10px] rounded'>Copy Invite</h6>}
                        </div>
                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.teacher?.name}</span><br></br>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                       <h6 className='text-[11px]'>Total Users : {d?.student?.length}</h6>
                       <div className='flex flex-wrap '>
                       {d?.student?.map((s)=><span className='bg-slate-200 text-[11px] p-[4px] m-[4px]'>{s?.name} NA</span>)}
                       </div>
                      </h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                        {formatTo12Hour(d?.booking_slots?.start_time)} - {formatTo12Hour(d?.booking_slots?.end_time)}
                      </h6>
                      <h6 className='flex   break-word  min-w-[180px] w-[180px]  px-2 py-1 font-[500] border-r'>{d?.teacher_remarks}</h6>
                      <h6 className='  break-word min-w-[120px] w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LL')}</h6>
                      <h6 className='flex items-start  min-w-[80px] w-[80px]  px-2 py-1 font-[500] '>
                        <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                        <AiOutlineDelete onClick={() => {setselecteddata(d);setmodal(true)}} className='mr-2' />
                      </h6>
                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-3 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div>
                          <h6 className='text-[13px] font-[700]'>{d?.section_name}</h6>
                          <h6 className='text-[11px] text-slate-600'>Class No : {d?.class?.label}</h6>
                        </div>
                        <div className='flex items-center -mr-1.5'>
                          <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('edit', { state: d })} /></span>
                          <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={() => {setselecteddata(d);setmodal(true)}} /></span>
                        </div>
                      </div>

                      {(d?.class_completed === 'Pending' && d?.meet_link) &&
                      <div className='flex items-center gap-1.5 mt-2'>
                        <h6 onClick={()=>openMeetfun(d)} className='cursor-pointer w-max bg-blue-100 font-[600] px-2 py-1 text-[11px] rounded'>Join Meet</h6>
                        <h6 onClick={()=>copyInvite(d)} className='cursor-pointer w-max bg-orange-100 font-[600] px-2 py-1 text-[11px] rounded'>Copy Invite</h6>
                      </div>}

                      <h6 className='text-[11px] mt-2'><span className='font-[600]'>Teacher:</span> {d?.teacher?.name || '-'}</h6>
                      <h6 className='text-[11px] mt-1'><span className='font-[600]'>Booking:</span> {formatTo12Hour(d?.booking_slots?.start_time)} - {formatTo12Hour(d?.booking_slots?.end_time)}</h6>

                      <h6 className='text-[11px] mt-2 font-[600]'>Students ({d?.student?.length || 0})</h6>
                      <div className='flex flex-wrap'>
                        {d?.student?.map((s, si)=><span key={si} className='bg-slate-100 text-[11px] px-1.5 py-1 rounded m-[3px]'>{s?.name} NA</span>)}
                      </div>

                      {d?.teacher_remarks && <h6 className='text-[11px] mt-2'><span className='font-[600]'>Remarks:</span> {d?.teacher_remarks}</h6>}

                      <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('LL')}</h6>
                    </div>
                  ))}
                </div>
                </>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default DemoBookingList